App.prototype.setCookie = function (cookieName,cookieValue,daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString() + "; path=/";
};

App.prototype.getCookie = function (cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for(var i=0; i<allCookieArray.length; i++)
    {
        var temp = allCookieArray[i].trim();
        if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
    }
    return "";
};

App.prototype.cookieSupport = function () {
    App.prototype.setCookie("cookie-support", true, 31);

    if (!App.prototype.getCookie("cookie-support")){

        document.body.classList.add('cookies-unsupported');

    }

    return App.prototype.getCookie("cookie-support");
}();
